// Single source of truth for todo/task priority colors and labels.
// Values match the priority options of WPEToDoElementPopup (0 = none, 3 = high).
export function getPriorityColorMap(colors) {
  return {
    0: colors.grey,
    1: colors.success,
    2: colors.warning,
    3: colors.error,
  };
}

export const priorityLabelMap = {
  0: 'None',
  1: 'Low',
  2: 'Medium',
  3: 'High',
};
